import React, { useState } from "react";
import { Badge, Button } from "reactstrap";
import EditFlashcardModal from "./EditFlashcardModal";
import EditScenarioModal from "./EditScenarioModal";
import PracticeVoiceModal from "./PracticeVoiceModal";
import QuizStatusModal from "./QuizStatusModal";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import TrainingVideoModal from "./TrainingVideoModal";
import { formatFlashcardDisplayHtml } from "./formatFlashcardHtml";
import { formatScenarioDisplayHtml } from "./formatScenarioHtml";

const FlipFlashCard = ({ card, onAssign, refreshCards, onDelete, isScenario = false }) => {
  const [flipped, setFlipped] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [showQuizStatus, setShowQuizStatus] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const openVideoModal = () => setShowVideoModal(true);
  const closeVideoModal = () => setShowVideoModal(false);

const handleGenerateVideo = () => {
  if (!card?.flash_id) return;

  setIsGenerating(true);

  postDataAPI({
    serviceName: "traning_video_data",
    op: "generate-slides-video",
    flash_card_id: card.flash_id
  })
    .then((res) => {
      if (res.status === "ok") {
        // Optional: success message
        console.log("Video generation started", res);
        refreshCards();
        // Optional toast
        // toast.success("Video generation started!");
      } else {
        console.error("Video generation failed", res);
      }
    })
    .catch((err) => {
      console.error("API error", err);
    })
    .finally(() => {
      setIsGenerating(false);
    });
};


  return (
    <>
      <div
        className={`flip-card ${flipped ? "flipped" : ""}`}
        onClick={() => setFlipped(!flipped)}
      >
        <div className="flip-card-inner">
          {/* FRONT */}
          <div
            className="flip-card-face flip-card-front"
            style={
              card.image_name
                ? {
                    backgroundImage: `
                      linear-gradient(
                        rgba(35,35,35,.60),
                        rgba(35,35,35,.60)
                      ),
                      url(${card.image_name})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                  }
                : {
                  backgroundColor: "#c4bfbf"
                }
            }
          >
            <Badge color={isScenario ? "danger" : "primary"} pill className="mb-3">
              {isScenario ? "Scenario" : card.course_name}
            </Badge>

            <h4 className="fw-bold mb-2 front-title">
              {card.item_name}
            </h4>

            <p className="mb-0 front-text">
              Tap to flip
            </p>
          </div>

          {/* BACK */}
          <div className="flip-card-face flip-card-back">
            <div
              className="flashcard-content"
              dangerouslySetInnerHTML={{
                __html: isScenario
                  ? formatScenarioDisplayHtml(card.format_coching_script)
                  : formatFlashcardDisplayHtml(card.format_coching_script)
              }}
            />

            <div className="flashcard-actions">
              <hr />

              <div className="action-row">
                {!isScenario && (
                <Button
                  size="sm"
                  className={`action-btn action-quick ${
                    (card?.video_status === "Completed" || card?.video_status === "Processing" ||
                    card?.video_status === "Pending") ? "bg-success text-white" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (card?.video_status === "Completed") {
                      openVideoModal();
                    } else {
                      handleGenerateVideo();
                    }
                  }}
                  disabled={
                    isGenerating ||
                    card?.video_status === "Processing" ||
                    card?.video_status === "Pending"
                  }
                >
                  {isGenerating ? "⏳ Generating..." : "⚡ Quick"}
                </Button>
                )}

                <Button
                  size="sm"
                  className="action-btn action-quiz"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowQuizStatus(true);
                  }}
                >
                  👥 Quiz Status
                </Button>


                <Button
                  size="sm"
                  className="action-btn action-assign"
                  onClick={(e) => {
                    e.stopPropagation();
                    onAssign();
                  }}
                >
                  👤 Assign
                </Button>

                <Button
                size="sm"
                className="action-btn action-voice"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowVoiceModal(true);
                }}
              >
                🎤 Voice
              </Button>

              </div>

              <div className="action-row justify-content-center mt-2">
                <Button
                  size="sm"
                  className="action-btn action-edit"
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditOpen(true);
                  }}
                >
                  ✏️ Edit
                </Button>

                <Button size="sm" className="action-btn action-delete" onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                  }}>
                  🗑 Delete
                </Button>
              </div>
            </div>

            <p className="flip-back-text mb-0">Tap to flip back</p>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      {isScenario ? (
        <EditScenarioModal
          isOpen={editOpen}
          toggle={() => setEditOpen(false)}
          card={card}
          onSuccess={refreshCards}
        />
      ) : (
        <EditFlashcardModal
          isOpen={editOpen}
          toggle={() => setEditOpen(false)}
          card={card}
          onSuccess={refreshCards}
        />
      )}

      {showVoiceModal && (
        <PracticeVoiceModal
          isOpen={showVoiceModal}
          toggle={() => setShowVoiceModal(false)}
          card={card}
          isScenario={isScenario}
        />
      )}

    {showQuizStatus && (
      <QuizStatusModal
        isOpen={showQuizStatus}
        toggle={() => setShowQuizStatus(false)}
        flashCardId={card.flash_id}
        dishName={card.item_name}
      />
      )}

  {showVideoModal && (
      <TrainingVideoModal
      isOpen={showVideoModal}
      toggle={closeVideoModal}
      card={card}
    />
  )}

    </>
  );
};

export default FlipFlashCard;
